import { useEffect, useState } from "react";
import { HeartPulse } from "lucide-react";
import { useLang } from "@/context/LanguageContext";
import { api } from "@/lib/api";

const COLORS = { good: "text-emerald-400", meh: "text-amber-400", bad: "text-red-400" };
const EMOJIS = { good: "😊", meh: "😐", bad: "😞" };

export const PulsePanel = () => {
  const { t, lang } = useLang();
  const pu = t.dash.pulse;
  const [data, setData] = useState(null);

  useEffect(() => {
    api.get("/stats/pulse").then((r) => setData(r.data)).catch(() => {});
  }, []);

  if (!data || data.sent === 0) return null;

  return (
    <div className="bg-[#111111] border border-white/10 p-6 md:p-8 mb-10" data-testid="pulse-panel">
      <p className="flex items-center gap-2 text-xs uppercase tracking-[0.2em] text-white/40 mb-2">
        <HeartPulse className="w-4 h-4 text-emerald-400" /> {pu.title}
      </p>
      <p className="text-xs text-white/40 mb-6">{pu.hint.replace("{n}", data.sent)}</p>
      <div className="flex flex-wrap gap-8 mb-6">
        {["good", "meh", "bad"].map((k) => (
          <div key={k} data-testid={`pulse-count-${k}`}>
            <p className={`font-display text-3xl font-semibold ${COLORS[k]}`}>
              {EMOJIS[k]} {data.answers[k]}
            </p>
            <p className="text-xs text-white/40 uppercase tracking-widest mt-1">{pu[k]}</p>
          </div>
        ))}
      </div>
      {data.recent.length > 0 && (
        <div className="space-y-2" data-testid="pulse-recent">
          {data.recent.map((r, i) => (
            <p key={i} className="text-xs text-white/60">
              {EMOJIS[r.answer]} <span className="font-semibold text-white/80">{r.name}</span>
              {r.at && (
                <span className="text-white/30"> · {new Date(r.at).toLocaleDateString(lang === "fr" ? "fr-BE" : "en-GB", { day: "numeric", month: "short" })}</span>
              )}
            </p>
          ))}
        </div>
      )}
    </div>
  );
};
